import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  @Input() userId;

  constructor() { }

  ngOnInit() {
    
  }

  logout(){
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts